import { ProductEvent } from "@classdojo/log-client/lib/client/client";

function executeCommand(cmd: string, queryParams: Record<string, string | number | boolean> = {}) {
  const iFrame: HTMLElement = document.createElement("IFRAME");
  queryParams._cacheDefeat = new Date().getTime();
  const urlSearchParams = Object.entries(queryParams).reduce((params, [key, value]) => {
    params.set(key, encodeURIComponent(value));
    return params;
  }, new URLSearchParams());
  const url = new URL(cmd);
  url.search = urlSearchParams.toString();
  iFrame.setAttribute("src", url.toString());
  document.body.appendChild(iFrame);
  iFrame.parentNode?.removeChild(iFrame);
}

export function init() {
  executeCommand("classdojo://command/init");
}

export const showNativeNav = (shouldShow: boolean) => {
  executeCommand("classdojo://command/showNav", { shouldShow });
};

export const closeWebview = () => {
  executeCommand("classdojo://command/close");
};

export function openSalesPage() {
  executeCommand("classdojo://command/openSalesPage");
}

export function openPointsSheet() {
  executeCommand("classdojo://command/openPointsSheet");
}

export const logEvent = (event: ProductEvent) => {
  executeCommand("classdojo://command/logEvent", { name: event.eventName, metadata: JSON.stringify(event.metadata) });
};
